import React, { useState } from "react";
import { postRequest } from "../../../utils/request";
import { apiUrl } from "../../../utils/apiUrl";
import Form from "./Form";

const Create = ({getUbicaciones, toggle}) => {
    const [errors, setErrors] = useState([]);

    const createUbicacion = async (event) => {
        event.preventDefault();

        const data = new FormData(event.target);
        const response = await postRequest(apiUrl("ubicaciones"), data);
    
        if (response.success) {
            getUbicaciones();
            toggle();
        }
        if (response.code === 422) {
            setErrors(response.data.message);
        }
    };

    return <form method='post' onSubmit={createUbicacion}>
        <div className='popup__header'>Nueva Ubicación de inventario</div>
        <div className='popup__body'>
            <Form ubicacion={{}} errors={errors} />
        </div>
        <div className='popup__footer'>
            <button
                type='button'
                onClick={toggle}
                className='btn btn-plain'>
                Cancelar
            </button>
            <button type='submit' className='btn btn-primary'>
                Crear
            </button>
        </div>
    </form>;
};

export default Create;